// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5609229f","431":"f4905950","488":"5cbd2d2c","667":"d6d522ae","720":"779ad018","908":"1528c32b","977":"f7febf40"}[chunkId] + ".chunk.js";
};